export default "__VITE_ASSET__DKFXUpwA__"